// Retourne le chemin d'accueil selon le rôle utilisateur
// role: chaîne (ex: 'patient' | 'doctor' | 'admin'...) ; id: identifiant patient optionnel
export function homeByRole(role, id) {
  if (!role) return "/";
  const r = String(role).trim().toLowerCase();

  if (r === "doctor" || r === "medecin") return "/feeddoctor";

  // patient (requiert id pour feed personnalisé)
  if (r === "patient") {
    if (id) return `/feed/${encodeURIComponent(String(id))}`;
    return "/feed"; // fallback générique
  }

  // Par défaut, renvoyer vers landing
  return "/";
}

export default homeByRole;
